(function() {
'use strict';

//this directive exists only to self destruct as soon as angular receives an unblock
const TR = angular.module('TR');
TR.directive('selfDestruct', function(broker) {
    return {
        restrict: 'A',
        link(scope, el) {
            broker.subscribe('SelfDestructDirective', 'selfdestruct', function() {
                el.remove();
                broker.unsubscribe('SelfDestructDirective', 'selfdestruct');
            });
        }
    };
});
})();
